export function truncateAfterWord(text: string, length: number) {
  if (text && text.length > length) {
    const exactTextLength = text.substr(0, length);
    text = text.substr(0, Math.min(exactTextLength.length, exactTextLength.lastIndexOf(' '))) + ' ...';
  }

  return text;
}
